import { useEffect } from 'react'
import { useStripe as useStripeOriginal } from '@stripe/react-stripe-js'
import { usePostHog } from '@posthog/react'
import toast from 'react-hot-toast'

let stripeErrorHandled = false

export const useStripeWithHandling = () => {
  const stripe = useStripeOriginal()
  const posthog = usePostHog()

  useEffect(() => {
    const handleError = () => {
      if (window.stripeFailed && !stripeErrorHandled) {
        stripeErrorHandled = true
        if (posthog) {
          posthog.capture('stripe_load_error', { source: 'useStripeWithHandling' })
        }

        toast.error(
          'Unable to start the payment process. Please check your network or ad blocker and refresh the page, or use the Paypal option.',
          { id: 'stripe-error' }
        )
      }
    }

    if (window.stripeFailed) {
      handleError()
    }
    window.addEventListener('stripe-load-error', handleError)

    return () => {
      window.removeEventListener('stripe-load-error', handleError)
    }
  }, [posthog])

  return stripe
}
